import { Injectable } from '@angular/core';
import { UnloadDeviceBaseService } from './base/unload-device-base.service';

@Injectable({
    providedIn: 'root',
})
export class UnloadDeviceService extends UnloadDeviceBaseService {
    constructor() {
        super();
    }
}
